export enum WellBeingQuestionTypeEnumes {
  STRING = 'String',
  SCALE = 'Scale',
  COUNTER = 'Counter',
}
